import bookaseatbanner from '../../assets/images/gallery/gallery-1.jpg';

import { Col, Container, Row } from "react-bootstrap";
// New package flip-card
import { FlipCard } from '@veeyaainnovatives/flip-card';
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useState, useEffect } from 'react';

const AboutUsSection = ({ handleShow }) => {
    const [contactData, setContactData] = useState({});

    // Fetch contact data from public folder
    useEffect(() => {
        const fetchContactData = async () => {
            try {
                const response = await fetch('/static_datas/contact.json');
                const data = await response.json();
                setContactData(data);
            } catch (error) {
                console.error('Error loading contact data:', error);
            }
        };
        fetchContactData();
    }, []);

    return (

        <Container id="contactUs">
            <div className="bookaseat-design position-relative">

                <div className="text-center">
                    <h1 className="courses-title mb-md-4">About Sathiesh Design Studio</h1>
                    <p className="course-syllabus-desc pb-md-5 pb-3">
                        Sathiesh Design Studio is Chennai’s first Single-Window Online Approval + Design–Build Studio, integrating architecture, interiors, construction, structural engineering, valuation, and 3D VR/AR into one seamless system.
                    </p>
                </div>

                <Row>

                    {/* CARD 1 */}
                    <Col md={4}>
                        <FlipCard
                            icon="fa-regular fa-chess-queen"
                            frontTitle="Awards"
                            backTitle="Awarded: Chennai's First Single-Window Online Plan Approval Studio"
                            backDescription="Clients submit documents digitally → we manage design + approvals + construction flawlessly."
                            className="acheivements-card mb-4"
                            backBackgroundColor="#d7e4d5"
                        />
                    </Col>

                    {/* CARD 2 */}
                    <Col md={4}>
                        <FlipCard
                            icon="fa-regular fa-comments"
                            frontTitle="Live Project Tracker"
                            backTitle="Live Project Tracker – 24/7 Client Access"
                            backDescription="Track site progress, materials, approvals, payments, and timelines from your phone."
                            className="acheivements-card mb-4"
                            backBackgroundColor="#d7e4d5"
                        />
                    </Col>

                    {/* CARD 3 */}
                    <Col md={4}>
                        <FlipCard
                            icon="fa-solid fa-vihara"
                            frontTitle="Best Vaastu Consultant"
                            backTitle="Best Vaastu Consultant for 35 Years"
                            backDescription="Get your house built according to Vaastu."
                            className="acheivements-card mb-4"
                            backBackgroundColor="#d7e4d5"
                        />
                    </Col>

                </Row>

                {/* BUTTONS */}
                <div className='text-center mt-5'>

                    <Button 
                        className="btn-bookaseat blocks"
                        onClick={handleShow}
                    >
                        Know More
                    </Button>

                    <Button
                        className="btn-bookaseat-outline blocks ms-xl-3 mt-3 mt-xl-0 call-us-button"
                        variant="outline"
                        borderWidth="3px"
                        icon="fa fa-phone me-2"
                        defaultText="Call Us Anytime"
                        hoverText={contactData.phone || ''}
                        onClick={() => {
                            if (contactData.phone) {
                                window.location.href = `tel:${contactData.phone.replace(/\s/g, '')}`;
                            }
                        }}
                    />

                </div>
            </div>
        </Container>

    );
}

export default AboutUsSection;
